import { sortByPreset } from './SortByPreset.js'

export const returnNavItems = () => {
  const leftNavString = document.getElementById(
    'left-nav-resource-bundle-cti-advisor'
  )
  const leftNavStringData = JSON.parse(leftNavString.innerText)
  const pageNameSplit = window.location.pathname.split('/')

  let pageName = ''

  if (pageNameSplit[pageNameSplit.length - 1] == '') {
    pageName = pageNameSplit[pageNameSplit.length - 2]
  } else {
    pageName = pageNameSplit[pageNameSplit.length - 1]
  }

  const labels = getNavLabels(leftNavStringData.navItems, pageName)

  return sortByPreset(labels)
}

const getNavLabels = (navItems, pageName) => {
  const labels = []
  const investor = window.location.href.indexOf('investor') > 1

  navItems.forEach((navItem) => {
    const prop = Object.keys(navItem)[0]

    if (prop.includes(pageName)) {
      const item = {}

      item.navLabel = navItem[prop]
      item.navAnchor = prop.split('.')[1]

      // investor and advisor are sharing the same resource bundle for contact us, this accounts for investor exceptions
      if (
        investor &&
        (item.navLabel === 'Managed Accounts' ||
          item.navLabel === 'Model Portfolios' ||
          item.navLabel === 'Registration & Login Issues')
      ) {
        return
      } else if (investor && item.navLabel === 'Retirement Plans & VITs') {
        item.navLabel = 'Retirement Plans'
        item.navAnchor = 'retirement-plans'
      }

      labels.push(item)
    }
  })

  return labels
}
